/**
 * Prépare une valeur stockée en base pour l’attribut `src` d’un iframe Maps.
 *
 * Erreurs fréquentes :
 * - collage de la balise `<iframe ...>` au lieu de l’URL seule ;
 * - `&#39;` / `&apos;` (entités HTML) dans l’URL au lieu de `'` ou `%27` ;
 * - guillemet + ` width="600"` collés après l’URL ;
 * - espaces en fin de chaîne.
 */
export function normalizeGoogleMapsEmbedUrl(raw: string): string {
  if (!raw) return "";
  let s = raw.trim();

  const fromIframe = s.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  if (fromIframe) {
    s = fromIframe[1].trim();
  }

  const quoteAt = s.indexOf('"');
  if (quoteAt > 0) {
    s = s.slice(0, quoteAt).trim();
  }

  s = s
    .replace(/&#39;/gi, "%27")
    .replace(/&apos;/gi, "%27")
    .replace(/&amp;/g, "&");

  return s.trim();
}
